import React, { Component } from "react";

import Doctor from "./doctor";
import "./time-ext.css";
import ListItem from "./list-item";
import Clinic from "./clinic";
import List from "./list";
import {POINT_TYPE_FREE} from "../../../point-types";

export default class TimeExt extends Component {
    static get defaultProps() {
        return {
            photoUrl: null,
            name: null,
            tags: null,
            address: null,
        };
    }

    static get propTypes() {
        return {
            // photoUrl: React.PropTypes.string,
            // name: React.PropTypes.string,
            // tags: React.PropTypes.object,
            // address: React.PropTypes.string,
        };
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    renderClinics() {
        let clinics = this.props.item.clinics
        let classClinic = 'appointment-container_points--margin';
        if (!!this.props.clinic){
            clinics = clinics.filter(item => item.id === this.props.clinic)
            classClinic = ''
        }

        console.log('clinics',clinics)
        const elements = clinics.map((item, key) => {
            return (
                <div key={key} >
                    {!this.props.clinic&&<Clinic

                        name={item.info.name}
                        address={item.info.address}
                    />}
                    <div  className={`appointment-container_points ${classClinic}`}>
                        {this.renderPoints(item.points)}
                    </div>
                </div>
            );
        });

        return <List>{elements}</List>;
    }
    renderPoints(items){
        console.log('items',items)
        const elements = items.points.map((item, key) => {
            if (item.status === POINT_TYPE_FREE) {
                let nextView = "ContactsView";
                let propsView = {
                    time: item.time,
                };
                //console.log('item.doctors',item.time,item.doctors)
                if (this.props.openWithoutDoctor){
                    if (item.doctors.length === 1){
                        nextView = "ContactsView";
                        propsView = {
                            time: item.time,
                            doctor: item.doctors[0],
                        }
                    }else {
                        nextView = "DoctorView";
                        propsView = {
                            time: item.time,
                            doctorsIds: item.doctors,
                        }
                    }

                }
                return (
                    <ListItem
                        key={key}
                        isActive={true}
                        hasStatusIndicator={true}
                        onClick={() => this.props.gotoNextView({
                            breadcrumbName: item.time,
                            nextView: nextView ,
                            props: propsView
                        })}>

                        {item.time}
                    </ListItem>
                );
            } else {
                return null;
            }
        });
        return <div><List>{elements}</List></div>;
    }

    render() {

        console.log('this.props',this.props.props)
        const  doctor = this.props.item.info
        let doctorClass = 'appointment-time-ext--one';
        if (!this.props.doctor){
            doctorClass = '';
        }
        return (
            <div className={`appointment-time-ext ${doctorClass}`}>


                {!this.props.doctor&&<Doctor
                    name={doctor.name}
                    photoUrl={doctor.photoUrl}
                    tags={{
                        seesChildren: (doctor.seesChildren),
                        seesAdult: (doctor.seesAdult)
                    }}/>}
                <div  className="appointment-container appointment-container--second">
                    {this.renderClinics()}
                </div>


            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/time-ext.js
 **/